import { render, staticRenderFns } from "./Daan.vue?vue&type=template&id=b424da0e&scoped=true&"
import script from "./Daan.vue?vue&type=script&lang=js&"
export * from "./Daan.vue?vue&type=script&lang=js&"
import style0 from "./Daan.vue?vue&type=style&index=0&id=b424da0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b424da0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
